<div class="text-with-icon">
    <img [src]="icon">
    <span>{{ title }}</span>
</div>